import { ACTIONS, ActionType } from '../constants/actions'
import callSecureAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import store from '../../redux/store'

interface EventMetadata {
    [key: string]: unknown
}

interface LogEventPayload {
    userId: string
    roadmapId: string
    organizationId: string
    action: ActionType
    metadata?: EventMetadata
}

const useEventLogger = () => {
    const { getTokenSilently } = useAuth0()

    /**
     * `roadmapId` overrides the roadmap the event is filed against. The default -- whichever
     * roadmap is currently selected -- is wrong for the org-admin panel, where the roadmap being
     * administered has nothing to do with the one the admin happens to have open.
     */
    const logEvent = async (
        action: ActionType,
        metadata: EventMetadata = {},
        { roadmapId }: { roadmapId?: string } = {}
    ): Promise<void> => {
        const payload: LogEventPayload = {
            userId: store.getState().userRecord._id,
            roadmapId: roadmapId ?? store.getState().strategy._id,
            organizationId: store.getState().strategy.organizationId,
            action,
            metadata,
        }

        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const response = await callSecureAPI(endpoints.logEvent.url, endpoints.logEvent.method, token, payload)

            if (response.success) {
                console.log('Event logged successfully')
            }
        } catch (error) {
            console.error('Event logging error:', error)
        }
    }

    return { logEvent, ACTIONS }
}

// import useEventLogger from '../hooks/useEventLogger';
// logEvent(ACTIONS.CREATE, { itemType: 'Document', itemId: 'doc123' });
export default useEventLogger
